const IMG = "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function AuthShell({ eyebrow, title, subtitle, children }) {
  return (
    <div className="container-x grid min-h-[calc(100vh-72px)] items-center gap-12 py-14 lg:grid-cols-2">
      <div className="mx-auto w-full max-w-md">
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-3 font-display text-4xl font-semibold tracking-tighter text-white">{title}</h1>
        <p className="mt-3 text-slate-400">{subtitle}</p>
        <div className="mt-10">{children}</div>
      </div>
      <div className="relative hidden overflow-hidden rounded-3xl border border-line lg:block">
        <img src={IMG} alt="Minimalist estate" className="h-[620px] w-full object-cover" />
        <div className="absolute inset-x-6 bottom-6 rounded-2xl border border-white/10 bg-obsidian/70 p-6 backdrop-blur-xl">
          <p className="font-display text-xl text-white">Stocks and real estate in one portfolio.</p>
          <p className="mt-2 text-sm text-slate-400">Track cash, holdings and requests from your Meridian dashboard.</p>
        </div>
      </div>
    </div>
  );
}
